import { IOption } from "@evergis/ui";
import { useLayerSelectHandlers } from "./useLayerSelectHandlers";

export function useLayerSelectOptions(name?: string, noFetch = false): (items: IOption[]) => void {
  const handlers = useLayerSelectHandlers(name, noFetch);

  return (items: IOption[]) => {
    const [{ value }] = items;

    if (handlers[value]) {
      handlers[value]();
    }
  };
}
